module.exports = __webpack_public_path__ + "img/17.8884aba4.png";